export const MODAL_CSS = `:host { all: initial; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; }
* { box-sizing: border-box; }

.overlay {
  position: fixed; inset: 0;
  width: 100vw; height: 100svh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2147483000;
  display: flex; align-items: center; justify-content: center;
  opacity: 0; transition: opacity 200ms ease-out;
  overflow: hidden;
  /* Без этого закрытая (opacity:0) модалка перехватывает все клики на странице
     z-index'ом 2147483000 — повторный клик по data-forma-open уходит в overlay,
     а не в кнопку, и модалка не открывается. */
  pointer-events: none;
}
.overlay.visible { opacity: 1; pointer-events: auto; }

/* Прозрачный контейнер вокруг iframe (радиус/тень задаёт сам iframe). */
.modal {
  position: relative;
  display: flex; flex-direction: column;
  max-width: 1172px;
  opacity: 0;
  transition: opacity 200ms ease-out;
}
.overlay.visible .modal { opacity: 1; }

.iframe {
  width: min(1171px, 100vw);
  height: min(711px, 100svh);
  max-height: 100svh;
  border: 0;
  border-radius: 25px;
  display: block;
  background: #fff;
}

.skeleton {
  position: absolute; inset: 0;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 25px;
  z-index: 1;
}
@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }

.fallback {
  position: absolute; inset: 0;
  background: #fff; z-index: 3;
  border-radius: 25px;
  display: none; flex-direction: column;
  align-items: center; justify-content: center;
  gap: 16px; padding: 20px; text-align: center;
}
.fallback.visible { display: flex; }
.fallback a { color: #4a90e2; text-decoration: underline; }

/* Mobile: fullscreen без отступов и bottom-sheet. */
@media (max-width: 720px) {
  .overlay { align-items: stretch; justify-content: stretch; }
  .modal { max-width: none; width: 100%; height: 100svh; }
  .iframe {
    width: 100vw; height: 100svh;
    border-radius: 0;
  }
  .skeleton, .fallback { border-radius: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .overlay, .modal { transition: none; }
  .skeleton { animation: none; }
}
`;
